import { callApi } from '../utils';

const base = (resource) => `/saved-filters/${resource}`;

export const fetchSavedFilters = (resource) => callApi(base(resource));

export const createSavedFilter = (resource, payload) =>
  callApi(base(resource), payload, 'post');

export const updateSavedFilter = (resource, id, payload) =>
  callApi(`${base(resource)}/${id}`, payload, 'patch');

export const deleteSavedFilter = (resource, id) =>
  callApi(`${base(resource)}/${id}`, {}, 'delete');
